"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LicenseGroup = function LicenseGroup(props) {
  var title = props.title,
    pawns = props.pawns,
    name = props.name;
  var showFilters = pawns.length > 5; // no need if small table

  var columns = [{
    name: 'username',
    label: 'Username',
    sort: true,
    filter: showFilters
  }, {
    name: 'firstName',
    label: 'First Name',
    sort: true,
    filter: showFilters
  }, {
    name: 'lastName',
    label: 'Last Name',
    sort: true,
    filter: showFilters
  }, {
    name: 'group',
    label: 'Group',
    sort: true,
    filter: showFilters
  }];
  var expireColumn = {
    name: 'expiresDate',
    label: 'Expired',
    sort: true,
    filter: showFilters
  };
  if (name === 'extend') {
    columns.splice(3, 0, _objectSpread(_objectSpread({}, expireColumn), {}, {
      label: 'Expires'
    }));
  } else if (name === 'renew') {
    columns.splice(3, 0, expireColumn);
  } else if (name === 'notEnough') {
    columns.splice(3, 0, {
      name: 'licenseStatus',
      label: 'License Status',
      sort: true,
      filter: showFilters,
      filterSettings: {
        type: 'selectbox',
        options: [{
          label: 'None',
          value: 'none'
        }, {
          label: 'Active',
          value: 'active'
        }, {
          label: 'Expired',
          value: 'expired'
        }]
      }
    }, _objectSpread(_objectSpread({}, expireColumn), {}, {
      label: 'Expire Date'
    }));
  }
  var renderTable = function renderTable() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].table
    }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
      name: name,
      columns: columns,
      rowKey: "pawnId",
      data: pawns.map(function (p) {
        return {
          pawnId: p.pawn.pawnId,
          username: p.user.username,
          firstName: p.user.firstName,
          lastName: p.user.lastName,
          expiresDate: (0, _get2["default"])(p, 'ownedLicenseList[0].expiresDate', null),
          licenseStatus: (0, _get2["default"])(p, 'licenseStatus', 'none'),
          group: p.parentGroup.anyGroup.group.label
        };
      }),
      perPage: 10,
      showPerPageOptions: false,
      hideShowingRowsSummary: !showFilters
    }));
  };
  if (name === 'notEnough') {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: "alert alert-danger"
    }, title), renderTable());
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].hiddenBlockWrapper
  }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: title
  }, renderTable()));
};
var _default = exports["default"] = LicenseGroup;